import { render, staticRenderFns } from "./payout-value-page.vue?vue&type=template&id=24bbe9dd&scoped=true"
import script from "./payout-value-page.vue?vue&type=script&lang=js"
export * from "./payout-value-page.vue?vue&type=script&lang=js"
import style0 from "./payout-value-page.vue?vue&type=style&index=0&id=24bbe9dd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbe9dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bbe9dd')) {
      api.createRecord('24bbe9dd', component.options)
    } else {
      api.reload('24bbe9dd', component.options)
    }
    module.hot.accept("./payout-value-page.vue?vue&type=template&id=24bbe9dd&scoped=true", function () {
      api.rerender('24bbe9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/payout-value-page.vue"
export default component.exports